module.exports = __webpack_public_path__ + "media/images/icon_photo-910742345f39dc155cc0e2beb56a08f0.png";